import { createContext, useContext, useReducer } from 'react';
import { BudgetActionSearchState, BudgetActionSearchReducer, ACTION_TYPES } from './budget-action-search-reducer';

const BudgetActionSearchContext = createContext<BudgetActionSearchState | undefined>(undefined);
const BudgetActionSearchDispatchContext = createContext({} as any);

const BudgetActionSearchProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: BudgetActionSearchState = {
        parameters: {},
        budgetPrograms: [],
        searchTrigger: 0,
    };
    const [state, dispatch] = useReducer(BudgetActionSearchReducer, initialState);
    return (
        <BudgetActionSearchContext.Provider value={state}>
            <BudgetActionSearchDispatchContext.Provider value={dispatch}>
                {children}
            </BudgetActionSearchDispatchContext.Provider>
        </BudgetActionSearchContext.Provider>
    );
};

const useBudgetActionSearchState = () => {
    const context = useContext(BudgetActionSearchContext);
    if (!context) throw new Error('useBudgetActionSearchState must be used within BudgetActionSearchProvider');
    return context;
};

const useBudgetActionSearchDispatch = () => {
    const context = useContext(BudgetActionSearchDispatchContext);
    if (!context) throw new Error('useBudgetActionSearchDispatch must be used within BudgetActionSearchProvider');
    return context;
};

export { BudgetActionSearchProvider, useBudgetActionSearchState, useBudgetActionSearchDispatch, ACTION_TYPES };
